export default __webpack_public_path__ + "static/media/frame-hero.dbb426f7.png";